import { ZendeskWidgetModules } from '../../../types/zendesk.d';
import { rescaleZendeskLauncher, styleZendeskWidget } from './zendeskWidgetStyleApi';
import {
  onZendeskLauncherClick,
  onZendeskWidgetClick,
  scriptZendeskWidget
} from './zendeskWidgetScriptApi';

/** mutation observers definition */

let launcherObserver: MutationObserver | null = null;
let widgetObserver: MutationObserver | null = null;

export const setZendeskLauncherObserver = (callback: () => void, onClick?: () => void): void => {
  if (callback != null && typeof callback === 'function') {
    launcherObserver = new MutationObserver((mutationList: MutationRecord[]) => {
      mutationList.forEach(mutation => {
        if (mutation.target.nodeName == 'DIV') {
          if (mutation.addedNodes.length) {
            const addedNode = mutation.addedNodes[0] as HTMLElement;

            if (addedNode.tagName === 'IFRAME') {
              if (addedNode.id === ZendeskWidgetModules.Launcher) {
                callback();

                if (onClick != null && typeof onClick === 'function') {
                  onZendeskLauncherClick(onClick);
                }
              }
            }
          }
        }
      });
    });
  }
};

export const setZendeskWidgetObserver = (onClick?: () => void): void => {
  widgetObserver = new MutationObserver((mutationList: MutationRecord[]) => {
    mutationList.forEach(mutation => {
      if (mutation.target.nodeName == 'DIV') {
        if (mutation.addedNodes.length) {
          const addedNode = mutation.addedNodes[0] as HTMLElement;

          if (addedNode.tagName === 'IFRAME' && addedNode.id === ZendeskWidgetModules.Widget) {
            scriptZendeskWidget();
            styleZendeskWidget();

            if (onClick != null && typeof onClick === 'function') {
              onZendeskWidgetClick(onClick);
            }
          }
        }

        if (mutation.removedNodes.length) {
          const removedNode = mutation.removedNodes[0] as HTMLElement;

          if (removedNode.tagName === 'IFRAME' && removedNode.id === ZendeskWidgetModules.Widget) {
            rescaleZendeskLauncher();
          }
        }
      }
    });
  });
};

/** mutation observers connect/disconnect */

export const observeZendeskLauncher = (): void => {
  if (launcherObserver != null) {
    launcherObserver.observe(document.body, { childList: true, subtree: true });
  }
};

export const observeZendeskWidget = (): void => {
  if (widgetObserver != null) {
    widgetObserver.observe(document.body, { childList: true, subtree: true });
  }
};

export const unobserveZendeskLauncher = (): void => {
  if (launcherObserver != null) {
    launcherObserver?.disconnect();
  }
};

export const unobserveZendeskWidget = (): void => {
  if (widgetObserver != null) {
    widgetObserver?.disconnect();
  }
};
